import script from "./inline-action-confirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./inline-action-confirmation.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__